// GENERAL
import React from "react";

// COMPONENTS
import { BaseContainer, BaseText } from "../../../../../../components";

import OrderInvoiceList from "../invoices/OrderInvoiceList";

// TYPES
import { OrderInvoicesSectionProps } from "../../types";

const OrderInvoicesSection: React.FC<OrderInvoicesSectionProps> = ({
	invoiceData,
	reasonForRequestAndShippingInstructionsNotes,
	hostName,
	fields,
	currencyCharacter,
}) => {
	// CLASSES:

	const invoicesBaseContainerClasses =
		"flex flex-col items-start w-full py-3 px-4 h-full border-transparent";

	return (
		<>
			{invoiceData?.length !== 0 && hostName !== "PRUDENTIAL" && (
				<section
					className={` flex flex-col items-start h-full max-xl:w-full`}
				>
					<BaseContainer
						columnContainerClasses={invoicesBaseContainerClasses}
						columnShape="semi-rounded"
						borderColor="navy-200"
						backgroundColor="bg-navy-100"
						isDisabled={false}
						children={
							<div className="flex flex-col items-start justify-between w-full h-full">
								<div
									className={`${
										reasonForRequestAndShippingInstructionsNotes
											? ""
											: ""
									} flex flex-col w-full`}
								>
									<div className="flex">
										<BaseText
											text={
												fields?.labels
													?.invoicesSectionTitle ||
												"Invoices"
											}
											size="text-sm"
											fontFamily="font-omnes-medium"
											tag="h3"
											color="text-navy-500"
										/>
									</div>
									<div className="w-full py-3">
										<OrderInvoiceList
											items={invoiceData}
											fields={fields[3]?.INVOICES || []}
											currencyCharacter={
												currencyCharacter
											}
											labels={fields?.labels}
										></OrderInvoiceList>
									</div>
								</div>
								<div className="flex w-full items-end">
									<BaseText
										text={`${invoiceData?.length} ${fields?.labels?.invoiceCountSuffix}`}
										size="text-sm"
										fontFamily="font-omnes-regular"
										tag="h3"
										color="text-navy-300"
									/>
								</div>
							</div>
						}
					/>
				</section>
			)}
		</>
	);
};

export default OrderInvoicesSection;
